import { render, staticRenderFns } from "./BrainTournamentAges.vue?vue&type=template&id=20a55f26&scoped=true"
import script from "./BrainTournamentAges.vue?vue&type=script&lang=js"
export * from "./BrainTournamentAges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a55f26",
  null
  
)

export default component.exports